import { styled } from '@mui/material/styles';
import { SimpleShowLayout } from 'react-admin';

export const StyledSimpleShowLayout = styled(SimpleShowLayout)({
  padding: 0,
  '& .RaSimpleShowLayout-row': {
    margin: 0,
    lineHeight: 0,
  },
  '& .RaLabeled-label': {
    margin: 0,
  },
});
